'use strict';

module Patersons {
    export class BankDetailsChangeRequestCtrl extends TwoFactorAuthenticationCtrl {
        portfolioService: PortfolioService;
        accountId: string;
        bankAccountDetail: BankAccountDetail;
        saveAll: boolean;

        static $inject = ['$scope', '$uibModalInstance', 'identityService', 'portfolioService', 'account', 'bankAccountDetail', 'saveAll'];

        constructor($scope, $uibModalInstance, identityService, portfolioService, account, bankAccountDetail, saveAll) {
            super($scope, $uibModalInstance, identityService)

            this.portfolioService = portfolioService;

            this.accountId = account.accountId;
            this.bankAccountDetail = bankAccountDetail;
            this.saveAll = saveAll;

            this.scope.nameOfPdf = "Banking and Electronic Consent"
            this.scope.linkToPdf = "https://www.canaccordgenuity.com/494d20/globalassets/wealth-management-australia/documents/forms/banking-and-electronic-consent-form-pershing.pdf";
        }

        submit() {
            this.scope.isSubmitted = true;

            if (this.scope.twoFactorAuthForm.$invalid) {
                return;
            }

            this.scope.isBusy = true;
            this.bankAccountDetail.smsToken = this.scope.verificationCode;
            if(this.saveAll){
                this.portfolioService.updateAllBankDetails(this.accountId, this.bankAccountDetail)
                    .then((result) => {
                        this.modalInstance.close(true);
                    },
                    (reason) => {
                        this.handleErrorResponse(reason);
                    })
                    .finally(() => {
                        this.scope.isBusy = false;
                    });
            }else{
            
                this.portfolioService.updateBankDetails(this.accountId, this.bankAccountDetail)
                    .then((result) => {
                        this.modalInstance.close(true);
                    },
                    (reason) => {
                        this.handleErrorResponse(reason);
                    })
                    .finally(() => {
                        this.scope.isBusy = false;
                    });
            }  
        }
    }
}